/* AFPL market pages: one accordion row open at a time, per group. */
(function () {
  function bind(root) {
    root.querySelectorAll('.am-acc').forEach(function (group) {
      var rows = group.querySelectorAll('details');
      rows.forEach(function (row) {
        row.addEventListener('toggle', function () {
          if (!row.open) return;
          rows.forEach(function (other) {
            if (other !== row && other.open) other.open = false;
          });
        });
      });
    });
  }
  function init() { document.querySelectorAll('.afpl-mkt').forEach(bind); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
  document.addEventListener('shopify:section:load', function (e) { bind(e.target); });
})();
